import SiteHeader from "@/components/site/SiteHeader";
import SiteFooter from "@/components/site/SiteFooter";
import Seo from "@/components/Seo";

type PlaceholderPageProps = {
  title: string;
  path: string;
};

const PlaceholderPage = ({ title, path }: PlaceholderPageProps) => (
  <main className="min-h-screen bg-background">
    <Seo title={`${title} | Yootelco`} description={`${title} from Yootelco, enterprise messaging and voice solutions.`} path={path} />
    <SiteHeader />
    <section className="section-shell">
      <div className="mx-auto max-w-[900px] text-center">
        <h1 className="section-title">{title}</h1>
      </div>
    </section>
    <SiteFooter />
  </main>
);

export default PlaceholderPage;
